import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';
import { AlertColor, Box, Card, Grid, Typography } from '@mui/material';
import MediumTypography from '../../components/formlib/MediumTypography';
import ConsentSignature from './ConsentSignature';
import ConsentGRI from './ConsentJson/Consent-GRI.json';
import ConsentAssessment from './ConsentJson/Consent-Assessment.json';
import ConsentTelehealth from './ConsentJson/Consent-Telehealth.json';
import ConsentSavingsAcc from './ConsentJson/Consent-SavingsAcc.json';
import ConsentSspShare from './ConsentJson/Consent-SspShare.json';
import ConsentSspCommunicate from './ConsentJson/Consent-SspCommunicate.json';
import ConsentCommunicateWithMedical from './ConsentJson/Consent-CommunicateWithMedical.json';
import ConsentCommunicateWithFamily from './ConsentJson/Consent-CommunicateWithFamily.json';
import ConsentNoticeOfPrivacyPractices from './ConsentJson/Consent-NoticeofPrivacyPractices.json';
import ConsentLegalReleaseofRecords from './ConsentJson/Consent-LegalReleaseOfRecords.json';
import ConsentPWN from './ConsentJson/Consent-PWN.json';
import ConsentForChangeServiceDeliveryPlan from './ConsentJson/Consent-ServiceDeliveryPlan.json';
import ConsentInsuranceTemplate from './ConsentJson/Consent-Insurance.json';
import TitleText from '../../components/formlib/TitleText';
import ButtonComponent from '../../components/formlib/ButtonComponent';
import SingleLine from '../../components/formlib/SingleLine';
import ConsentGeneralInfo from './ConsentGeneralInfo';
import ConsentClientDetails, { Client } from './ConsentClientDetails';
import ConsentSspAgencyDetails from './ConsentSspAgencyDetails';
import { OptionType } from '../../utils/type';
import ConsentFormTextWithCheckbox from './ConsentFormTextwithCheckbox';
import {
  ConsentClientContact,
  ConsentClientSignature,
  ConsentDetailsType,
  ConsentInsurance,
  updateConsent,
} from '../../services/configApi/forms/Consent/ConsentServices';
import { useNavigate } from 'react-router';
import { LoaderContext, LoaderContextType } from '../../layouts/AppSidebar';
import SnackBarComponent from '../../components/formlib/SnackBarComponent';
import { CONSENT_DASHBOARD } from '../../routes/Routing';
import moment from 'moment';
import { ApiError, isCustomError } from '../../services/ApiResponseHandler';
import ConsentServiceDeliveryPlan from './ConsentServiceDeliveryPlan';
import dayjs from 'dayjs';
import CustomBackArrow from '../../components/imagepickers/backArrow';
import ProgramPanel from '../../components/forms/ProgramPanel';
import _, { debounce } from 'lodash';
import ModalPopup from '../../components/formlib/ModalPopup';
import { ConsentContext } from './ConsentProvider';
import TranslateWidget, { setLanguage } from '../../TranslateWidget';
import { UnSavedChangesContext } from '../../context/UnSavedChangesProvider';
import CommentTextbox from '../../components/formlib/CommentTextbox';
import DropdownComponent from '../../components/formlib/DropdownComponent';
import Textinput from '../../components/formlib/Textinput';
import DatePickerComponent from '../../components/formlib/DatePickerComponent';
import { datePickerMinDateMaxDateValidate } from '../../utils/dateUtil';
import { useMultiplePermissions } from '../../hooks/usePermissions';
import {
  DATE_FORMAT,
  LOCAL_DATE_TIME_UTC_FORMAT,
  REFERRAL_STATUS_KEY,
} from '../../services/Constant';
import { LookUpContext } from '../../context/LookUpContextProvider';
import ConsentInsuranceDetails from './ConsentInsuranceDetails';
import CheckBoxComponent from '../../components/formlib/CheckBoxComponent';

const excludedTypes = [
  'Assessment',
  'Telehealth',
  'SavingsAcc',
  'NoticeOfPrivacyPractices',
  'PriorWrittenNoticeForm',
  'ConsentForChangeServiceDeliveryPlan',
  'InsuranceConsent',
];

const consentInterventionCheckBox = [
  {
    id: '1',
    dataLabelId: 'ConsentEvaOrAssessment.labelText1',
    defaultDataLabelId:
      'An evaluation/assessment to determine eligibility, strengths and needs of the child.',
  },
  {
    id: '2',
    dataLabelId: 'ConsentEvaOrAssessment.labelText2',
    defaultDataLabelId:
      'A family-directed assessment to determine concerns, priorities and resources.',
  },
  {
    id: '3',
    dataLabelId: 'ConsentEvaOrAssessment.labelText3',
    defaultDataLabelId:
      'A child assessment to determine ongoing strengths and needs.',
  },
];

const consentHSACheckBox = [
  {
    id: '1',
    dataLabelId: 'ConsentSavingsAcc.labelText1',
    defaultDataLabelId:
      'I do not have an HSA. No action is needed at this time.',
  },
  {
    id: '2',
    dataLabelId: 'ConsentSavingsAcc.labelText2',
    defaultDataLabelId:
      'I do have an HSA. I have been given a copy of this HSA alert and understand that I must contact my HSA plan administrator at this time.',
  },
];

const consentHSA2CheckBox = [
  {
    id: '1',
    dataLabelId: 'ConsentSavingsAcc2.labelText1',
    defaultDataLabelId:
      '<b>Health Savings Account (HSA):</b> An account that allows employees with a qualifying high-deductible health plan to set aside pre-tax money to help pay for eligible medical expenses.  ',
  },
  {
    id: '2',
    dataLabelId: 'ConsentSavingsAcc2.labelText2',
    defaultDataLabelId:
      '<b>Flexible Spending Account (FSA):</b> An employer-sponsored benefit that allows employees to set aside  pre-tax dollars to pay for qualified medical expenses.',
  },
  {
    id: '3',
    dataLabelId: 'ConsentSavingsAcc2.labelText3',
    defaultDataLabelId:
      '<b>Neither:</b> I do not participate in an HSA or FSA.  ',
  },
];
const consentFormPwnOthers = [
  {
    id: '1',
    dataLabelId: 'ConsentPwnOthers.labelText',
    defaultDataLabelId: 'Enter activity or action here',
  },
];

const consentPWNIFSP = [
  {
    id: '1',
    dataLabelId: 'ConsentPWN.servicesLabelText1',
    defaultDataLabelId: 'The EI program is proposing to have an IFSP Meeting.',
  },

  {
    id: '2',
    dataLabelId: 'ConsentPWN.servicesLabelText2',
    defaultDataLabelId:
      'The EI program is proposing to make a change in your child’s EI services.',
  },
  {
    id: '3',
    dataLabelId: 'ConsentPWN.servicesLabelText3',
    defaultDataLabelId:
      'A change in EI services that you requested has been declined by the EI program.The EI program must explain in writing the reason(s) why they have decided not to implement your requested change.',
  },
  {
    id: '4',
    dataLabelId: 'ConsentPWN.servicesLabelText4',
    defaultDataLabelId:
      'The EI program is proposing a Transition Planning Conference.',
  },
];

const consentPWNIdentification = [
  {
    id: '1',
    dataLabelId: 'ConsentForms.pwnIdentificationLabelText1',
    defaultDataLabelId:
      'The EI program is proposing to complete an evaluation/assessment to determine if your child is eligible for EI services.',
  },

  {
    id: '2',
    dataLabelId: 'ConsentForms.pwnIdentificationLabelText2',
    defaultDataLabelId:
      'Your child is eligible or continues to be eligible for EI services.',
  },
  {
    id: '3',
    dataLabelId: 'ConsentForms.pwnIdentificationLabelText3',
    defaultDataLabelId: 'Your child is not eligible for EI services.',
  },
];

export const ConsentSignatureRadioData = [
  {
    value: 'primary',
    labelId: 'ConsentForms.RadioLabelA',
    defaultLabel: 'Primary Guardian',
  },
  {
    value: 'legal',
    labelId: 'ConsentForms.RadioLabelB',
    defaultLabel: 'Legal Guardian',
  },
];

export interface ConsentJson {
  [version: string]: {
    ProgramView: boolean;
    ExpiryDateView: boolean;
    ClientView: boolean;
    ReleaseClientView: boolean;
    InterventionView: boolean;
    RequestedView: boolean;
    UocView: boolean;
    UorView: boolean;
    SignatureView: boolean;
    StaffInitialsView: boolean;
    DisclaimerView: boolean;
    DisclaimerTitleView: boolean;
    PurposeText: PurposeText[];
    UocText: string;
    UocTextOld?: string;
    DisclaimerText: string;
    PWNType: boolean;
    verbalConsent: boolean;
    paperConsent: boolean;
  };
}

interface PurposeText {
  communication?: PurposeJson[];
  purpose?: PurposeJson[];
  id?: string;
  type?: string;
  dataLabelId?: string;
  defaultDataLabelId?: string;
}

interface PurposeJson {
  id: string;
  type: string;
  dataLabelId: string;
  defaultDataLabelId: string;
}

export const consentInitialValues: ConsentDetailsType = {
  type: '',
  name: '',
  consentId: '',
  version: 1,
  signedDate: '',
  revokedDate: null,
  status: 'Not Current',
  requestedDate: '',
  requester: {
    name: '',
    email: '',
    phone: '',
  },
  client: {
    id: '',
    name: '',
    dphId: '',
    gender: '',
    dob: '',
    address: '',
  },
  selectedContact: [],
  contact: [
    {
      id: '',
      name: '',
      address: '',
      email: '',
      phone: '',
      isGuardian: false,
      isPrimary: false,
      isLegalGuardian: false,
      type: '',
    },
  ],
  refusal: false,
  signatureType: 'primary',
  signature: [],
  programProposes: null,
  communicationMode: null,
  purpose: null,
  programDetails: {
    name: '',
    phoneNumber: '',
    email: '',
    addressLine1: '',
    addressLine2: '',
    faxNumber: '',
    website: '',
    city: '',
    state: '',
    zipCode: '',
    imageUrl: '',
  },
  ifsp: null,
  serviceDeliveryPlan: {
    isEligibleUntilThirdBirthday: '',
    eligibleTool: {
      id: '',
      label: '',
    },
    assessmentCompletionDate: null,
    reEstablishedDate: null,
    parentInitial: { id: '', label: '' },
    isChecked: false,
    participated: false,
    agreeDisagree: '',
    exceptionList: '',
    consent: false,
  },
  eligibility: null,
  other: false,
  otherContactName: '',
  othersComment: '',
  summary: '',
  description: '',
  selectedLanguage: 'en',
  uiVersion: 1,
  hsaConsentVersion: 1,
  dateMailed: null,
  initials: '',
  consentPwnType: {
    id: null,
    pwnType: null,
    pwnDescription: null,
  },
  consentInsurance: null,
  revokeSignature: null,
};

const ConsentReleaseInfo = () => {
  const navigate = useNavigate();
  const { consentDataJSON, selectedVersionNo } = useContext(ConsentContext);

  const [consentData, setConsentData] = useState<ConsentDetailsType | null>(
    null,
  );
  const [selectedVersion, setSelectedVersion] = useState<number>(0);
  const [pwnTypeLookup, setPwnTypeLookup] = useState<OptionType[]>([]);
  const [insuranceLookup, setInsuranceLookup] = useState<OptionType[]>([]);
  const { toggleLoader } = useContext(LoaderContext) as LoaderContextType;
  const { handleUpdateUnsavedChanges } = useContext(UnSavedChangesContext);
  const { lookups } = useContext(LookUpContext);

  const [open, setOpen] = React.useState(false);
  const [toastrVariable, setToastrVariable] =
    React.useState<AlertColor>('info');
  const [toastrDefaultMessage, setToastrDefaultMessage] = React.useState('');
  const [toastrId, setToastrId] = React.useState('');
  const [contacts, setContacts] = useState<OptionType[]>([]);
  const [guardianContacts, setGuardianContacts] = useState<OptionType[]>([]);
  const [contactSelected, setContactSelected] = useState<OptionType | null>(
    null,
  );
  const [revokeGuardian, setRevokeGuardian] = useState<OptionType | null>(null);
  const [sspData, setSspData] = useState<PurposeText[]>([
    { communication: [], purpose: [] },
  ]);

  const [selectedContact, setSelectedContact] = useState<
    ConsentClientContact[]
  >([]);
  const [initialSelectedContactId, setInitialSelectedContactId] = useState<
    string[]
  >([]);

  const [checked, setChecked] = useState(false);

  const [othersChecked, setOthersChecked] = useState(
    consentFormPwnOthers.map(() => ({
      checked: false,
    })),
  );

  const [requestedChecked, setRequestedChecked] = useState(
    consentData?.communicationMode?.length
      ? consentData.communicationMode.map(() => ({ checked: false }))
      : [],
  );

  const [purposeChecked, setPurposeChecked] = useState(
    consentData?.purpose?.length
      ? consentData.purpose.map(() => ({ checked: false }))
      : [],
  );

  const [selectedClient, setSelectedClient] = useState<Client>({
    name: '',
    dob: '',
    dphId: '',
    address: '',
    gender: '',
  });
  const [titleTextInfo, setTitleTextInfo] = useState('ConsentGRI.TitleText');

  const [otherContactName, setOtherContactName] = useState(
    consentData?.otherContactName,
  );
  const [otherInitialContactName, setOtherInitialContactName] = useState('');

  const [consentName, setConsentName] = useState(
    'General Release of Information',
  );
  const [consentDetails, setConsentDetails] =
    useState<ConsentDetailsType>(consentInitialValues);

  const [consentBackupDetails, setConsentBackupDetails] =
    useState<ConsentDetailsType>(consentInitialValues);

  const [programView, setProgramView] = useState<boolean>(false);
  const [expiryDateView, setExpiryDateView] = useState<boolean>(false);
  const [clientView, setClientView] = useState<boolean>(false);
  const [releaseClientView, setReleaseClientView] = useState<boolean>(false);
  const [uocView, setUocView] = useState<boolean>(false);
  const [interventionView, setInterventionView] = useState<boolean>(false);
  const [pwnTypeView, setPwnTypeView] = useState<boolean>(false);
  const [requestedView, setRequestedView] = useState<boolean>(false);
  const [uorView, setUorView] = useState<boolean>(false);
  const [signatureView, setSignatureView] = useState<boolean>(false);
  const [disclaimerView, setDisclaimerView] = useState<boolean>(false);
  const [disclaimerTitleView, setDisclaimerTitleView] =
    useState<boolean>(false);
  const [staffInitialsView, setStaffInitialsView] = useState<boolean>(false);
  const [isVerbalConsentView, setIsVerbalConsentView] =
    useState<boolean>(false);
  const [isPaperConsentView, setIsPaperConsentView] = useState<boolean>(false);
  const [btnName, setBtnName] = useState<boolean>(false);
  const [noppConsent, setNoppConsent] = useState<boolean>(false);
  const [legalConsent, setLegalConsent] = useState<boolean>(false);
  const [pwnForm, setPwnForm] = useState<boolean>(false);
  const [openModal, setOpenModal] = useState<boolean>(false);

  const [understandingConcent, setUnderstandingConcent] = useState(
    ConsentGRI[1].UocText,
  );
  const [disclaimer, setDisclaimer] = useState(ConsentGRI[1].DisclaimerText);
  const [expiryDate, setExpiryDate] = useState<string>('');

  const [interventionCheckBoxView, setInterventionCheckBoxView] = useState(
    consentInterventionCheckBox,
  );
  const [interventionChecked, setInterventionChecked] = useState(
    consentInterventionCheckBox.map(() => ({
      checked: false,
    })),
  );
  const [ifspCheckBoxView, setIfspCheckBoxView] = useState(consentPWNIFSP);
  const [interventionPwnChecked, setInterventionPwnChecked] = useState(
    consentPWNIFSP.map(() => ({
      checked: false,
    })),
  );

  const [eligibilityCheckBoxView, setEligibilityCheckBoxView] = useState(
    consentInterventionCheckBox,
  );

  const [eligibilityPwnChecked, setEligibilityPwnChecked] = useState(
    consentPWNIdentification.map(() => ({
      checked: false,
    })),
  );

  const [consentForChange, setConsentForChange] = useState<boolean>(false);
  const [consentInsurance, setConsentInsurance] = useState<boolean>(false);

  const [dropDownValidationState, setDropDownValidationState] =
    useState<boolean>(false);

  const [
    dropDownOtherContactValidationState,
    setDropDownOtherContactValidationState,
  ] = useState<boolean>(false);

  const [
    disableConsentDueToAssessmentCompletionDate,
    setDisableConsentDueToAssessmentCompletionDate,
  ] = useState<boolean>(false);

  const [
    disableConsentDueToReEstablishDate,
    setDisableConsentDueToReEstablishDate,
  ] = useState<boolean>(false);

  const [selectedLanguageValue, setSelectedLanguageValue] =
    useState<string>('');

  const translationId = useRef('Consent');

  const permissions = useMultiplePermissions([
    'backend.clients',
    'backend.in_active_referrals',
    'backend.consents',
  ]);
  const referralStatus = localStorage.getItem(REFERRAL_STATUS_KEY) ?? 'None';
  const [hasEditPermission, setHasEditPermission] = useState<boolean>(false);

  const isAuthorized =
    referralStatus === 'Inactive'
      ? permissions['backend.clients'].canEdit &&
        permissions['backend.in_active_referrals'].canEdit &&
        permissions['backend.consents'].canEdit
      : (permissions['backend.clients'].canEdit ||
          permissions['backend.in_active_referrals'].canEdit) &&
        permissions['backend.consents'].canEdit &&
        !(selectedLanguageValue !== '' && selectedLanguageValue !== 'en');

  useEffect(() => {
    if (!hasEditPermission || !isAuthorized) {
      const handleKeyDown = (e: KeyboardEvent) => {
        if (e.key === 'Tab') {
          e.preventDefault();
        }
      };
      document.addEventListener('keydown', handleKeyDown);
      return () => document.removeEventListener('keydown', handleKeyDown);
    }
  }, [hasEditPermission, isAuthorized]);

  useEffect(() => {
    if (lookups?.pwnType) {
      setPwnTypeLookup(() => {
        return lookups.pwnType.map((type) => {
          return {
            label: type.description,
            id: type.code,
          };
        });
      });
    }
    if (lookups?.pwnType) {
      setInsuranceLookup(() => {
        return lookups.consentInsurances.map((type) => {
          return {
            label: type.description,
            id: type.insuranceBackendId,
          };
        });
      });
    }
  }, [lookups]);

  useEffect(() => {
    if (consentDataJSON !== null) {
      if (consentDataJSON.signature.length > 0) {
        if (
          consentDataJSON.signature[0].id === '' &&
          consentDataJSON.signature[0].name === ''
        ) {
          setContactSelected(null);
        } else {
          setContactSelected({
            id: consentDataJSON.signature[0].id,
            label: consentDataJSON.signature[0].name,
          });
        }
      }
      if (consentDataJSON.revokeSignature) {
        setRevokeGuardian({
          id: consentDataJSON.revokeSignature.id,
          label: consentDataJSON.revokeSignature.name,
        });
      } else {
        setRevokeGuardian(null);
      }
      setConsentData(consentDataJSON);
      setSelectedVersion(selectedVersionNo);
    }
  }, [consentDataJSON]);

  useEffect(() => {
    if (consentDataJSON) {
      setInitialSelectedContactId(consentDataJSON?.selectedContact);
    }
  }, []);

  useEffect(() => {
    const extractedId = selectedContact.map((data) => data.id);
    if (
      _.isEqual(consentBackupDetails, consentDetails) &&
      _.isEqual(otherInitialContactName, otherContactName) &&
      _.isEqual(initialSelectedContactId, extractedId)
    ) {
      handleUpdateUnsavedChanges(false);
    } else {
      handleUpdateUnsavedChanges(true);
    }
  }, [
    consentDetails,
    otherInitialContactName,
    otherContactName,
    selectedContact,
    initialSelectedContactId,
  ]);

  const handleDisableConsentDueToAssessmentCompletionDate = (
    value: boolean,
  ) => {
    setDisableConsentDueToAssessmentCompletionDate(value);
  };

  const getPwnTypeLabel = (id: string) => {
    const pwnType = pwnTypeLookup.find((type) => type.id === id);
    return pwnType ? pwnType.label : '';
  };

  const handleDisableConsentDueToReEstablishDate = (value: boolean) => {
    setDisableConsentDueToReEstablishDate(value);
  };

  const getContacts = async (responseContact: ConsentClientContact[]) => {
    if (responseContact) {
      const contactList: OptionType[] = [];
      const guardianList: OptionType[] = [];
      responseContact.forEach((contact) => {
        const isReferralContact = contact.type === 'Referral Contact';
        const isFamilyContact = contact.type === 'Family';
        const isOtherContact =
          contact.type &&
          contact.type !== 'Family' &&
          contact.type !== 'Referral Contact';
        const prefixes = [
          contact.isPrimary && 'Primary',
          contact.isLegalGuardian && 'Legal',
        ].filter(Boolean);

        if (isReferralContact) {
          contactList.push({
            id: contact.id.toString(),
            label: contact.name,
          });
        } else if (isOtherContact) {
          contactList.push({
            id: contact.id.toString(),
            label: contact.name,
          });
        } else if (isFamilyContact && consentData?.selectedContact.length) {
          const isSelected = consentData.selectedContact.some(
            (id) => id.toString() === contact.id.toString(),
          );
          if (isSelected) {
            contactList.push({
              id: contact.id.toString(),
              label: contact.name,
            });
          }
        }

        if (contact.isGuardian) {
          guardianList.push({
            id: contact.id.toString(),
            label: `${contact.name}${
              prefixes.length > 0 ? ` - (${prefixes.join(', ')})` : ''
            }`,
          });
          contactList[contactList.length - 1].label = `${contact.name}${
            prefixes.length > 0 ? ` - (${prefixes.join(', ')})` : ''
          }`;
        }
      });
      setContacts(contactList);
      setGuardianContacts(guardianList);
    }
    return [];
  };

  const getContactInfo = (value: OptionType | null) => {
    if (value) {
      if (consentData && consentData.contact.length > 0) {
        return consentData.contact.filter((data: ConsentClientContact) => {
          return data.id.toString() === value.id;
        });
      }
      return [];
    }
    return [];
  };

  const onRequestedChecked = (value: boolean, index: number) => {
    const updateAction = [...requestedChecked];
    updateAction[index].checked = value;
    if (updateAction[index].checked) {
      setConsentDetails((prevConsentDetails) => ({
        ...prevConsentDetails,
        communicationMode:
          prevConsentDetails.communicationMode === null
            ? [index]
            : [...prevConsentDetails.communicationMode, index],
      }));
    } else {
      setConsentDetails((prevConsentDetails) => ({
        ...prevConsentDetails,
        communicationMode: (prevConsentDetails.communicationMode ?? []).filter(
          (i) => i !== index,
        ),
      }));
    }
    setRequestedChecked([...new Set(updateAction)]);
  };

  const onPurposeChecked = (value: boolean, index: number) => {
    const updateAction = [...purposeChecked];
    updateAction[index].checked = value;

    if (updateAction[index].checked) {
      setConsentDetails((prevConsentDetails) => ({
        ...prevConsentDetails,
        purpose:
          prevConsentDetails.purpose === null
            ? [index]
            : [...prevConsentDetails.purpose, index],
      }));
    } else {
      setConsentDetails((prevConsentDetails) => ({
        ...prevConsentDetails,
        purpose: (prevConsentDetails.purpose ?? []).filter((i) => i !== index),
      }));
    }
    setPurposeChecked([...new Set(updateAction)]);
  };

  const getUpdatedProgramProposes = (
    programProposes: number[] | null,
    index: number,
    isHsaSingleSelect: boolean,
  ): number[] => {
    if (isHsaSingleSelect || programProposes === null) {
      return [index];
    }
    return [...programProposes, index];
  };

  const onInterventionChecked = (value: boolean, index: number) => {
    const isHsaSingleSelect =
      consentDetails.type === 'SavingsAcc' &&
      consentDataJSON?.hsaConsentVersion === 2;
    const updateAction = [...interventionChecked];
    updateAction[index].checked = value;
    if (isHsaSingleSelect && value) {
      updateAction.forEach((item, i) => {
        if (i !== index) item.checked = false;
      });
    }
    if (updateAction[index].checked) {
      setConsentDetails((prevConsentDetails) => ({
        ...prevConsentDetails,
        programProposes: getUpdatedProgramProposes(
          prevConsentDetails.programProposes,
          index,
          isHsaSingleSelect,
        ),
      }));
    } else {
      setConsentDetails((prevConsentDetails) => ({
        ...prevConsentDetails,
        programProposes: (prevConsentDetails.programProposes ?? []).filter(
          (i) => i !== index,
        ),
      }));
    }
  };

  const onIFSPPwnChecked = (value: boolean, index: number) => {
    const updateAction = [...interventionPwnChecked];
    updateAction[index].checked = value;

    setConsentDetails((prevConsentDetails) => {
      const updatedIfsp =
        prevConsentDetails.ifsp !== null &&
        prevConsentDetails.ifsp !== undefined
          ? [...prevConsentDetails.ifsp]
          : [];

      if (updateAction[index].checked) {
        updatedIfsp.push(index);
      } else {
        const indexToRemove = updatedIfsp.indexOf(index);
        if (indexToRemove !== -1) {
          updatedIfsp.splice(indexToRemove, 1);
        }
      }

      return {
        ...prevConsentDetails,
        ifsp: updatedIfsp,
      };
    });

    setInterventionPwnChecked(updateAction);
  };

  const onEligibilityPwnChecked = (value: boolean, index: number): void => {
    const updateAction = [...eligibilityPwnChecked];
    updateAction[index].checked = value;
    if (value && index !== 0) {
      updateAction[index === 1 ? 2 : 1].checked = false;
    }

    setConsentDetails((prevConsentDetails) => ({
      ...prevConsentDetails,
      eligibility: updateAction
        .map((item, i) => (item.checked ? i : -1))
        .filter((i) => i !== -1),
    }));

    setEligibilityPwnChecked(updateAction);
  };

  const onOthersChecked = (value: boolean, index: number) => {
    const updateAction = [...othersChecked];
    updateAction[index].checked = value;

    setConsentDetails((prevConsentDetails) => ({
      ...prevConsentDetails,
      other: value,
      othersComment: value ? prevConsentDetails.othersComment : '',
    }));

    setOthersChecked(updateAction);
  };

  const onChecked = (value: boolean) => {
    if (!consentData) return;

    setConsentDetails((prevConsentDetails) => ({
      ...prevConsentDetails,
      refusal: value,
      revokeSignature: value ? prevConsentDetails.revokeSignature : null,
      revokedDate: value ? prevConsentDetails.revokedDate : null,
    }));
    if (!value) setRevokeGuardian(null);
    setChecked(value);
  };

  const getConsentTitleLabel = () => {
    if (consentDetails.type === '') {
      return '';
    }
    if (consentDetails.type === 'LegalReleaseofRecords') {
      return 'ConsentForms.contactTitleLegalReleaseofRecords';
    }
    return consentDetails.type === 'GRI'
      ? 'ConsentForms.contactTitleGRI'
      : 'ConsentForms.contactTitle';
  };

  const getConsentDefaultTitleLabel = () => {
    if (consentDetails.type === '') {
      return '';
    }
    if (consentDetails.type === 'LegalReleaseofRecords') {
      return 'Who can legally receive information about your child?';
    }
    return consentDetails.type === 'GRI'
      ? 'Release client information with'
      : 'Release client information to';
  };
  const getStatusCheck = () => {
    if (!consentData?.status) {
      return 'Not Current';
    }

    if (consentData.status === 'Revoked') {
      return 'Revoked';
    }

    return consentData.status;
  };
  const getExpiredDate = () => {
    if (noppConsent || pwnForm || !expiryDate) {
      return '';
    }

    return moment(expiryDate).local().format(DATE_FORMAT);
  };
  const getLabelId = () => {
    if (legalConsent) {
      return 'ConsentUOCTitle.legalConsent';
    }

    if (noppConsent) {
      return 'ConsentUOCTitle.NoticeforPrivacy';
    }

    if (pwnForm) {
      return 'ConsentUOCTitle.pwnForm';
    }

    return 'ConsentForms.understandingTitle';
  };
  useEffect(() => {
    if (consentData !== null) {
      setViews(consentData.type);
      const resultExpiry =
        consentData.type === 'NoticeOfPrivacyPractices' ||
        consentData.type === 'PriorWrittenNoticeForm'
          ? ''
          : getDateFormatedValue(consentData.signedDate?.toString() ?? '');
      setExpiryDate(resultExpiry ?? '');

      const resultRequested =
        consentData.requestedDate === ''
          ? new Date().toISOString()
          : consentData.requestedDate;
      const resultUpdateRequested =
        consentData.type === 'NoticeOfPrivacyPractices' ||
        consentData.type === 'LegalReleaseofRecords' ||
        consentData.type === 'PriorWrittenNoticeForm'
          ? ''
          : resultRequested;

      const resultSigned =
        consentData.signedDate === '' ? null : consentData.signedDate;

      const resultSignature = consentData.signature.map(
        (item: ConsentClientSignature) => {
          return {
            ...item,
            date: item.date ? item.date : '',
          };
        },
      );

      const statusCheck = getStatusCheck();

      if (statusCheck === 'Revoked') {
        setHasEditPermission(false);
      } else if (consentData.type === 'PriorWrittenNoticeForm') {
        setHasEditPermission(true);
      } else if (consentData.signature.length > 0) {
        if (
          consentData.signature[0].rowKey ||
          consentData.signature[0].verbal ||
          consentData.signature[0].paperConsent
        ) {
          setHasEditPermission(false);
        } else {
          setHasEditPermission(true);
        }
      } else if (consentData.signature.length === 0) {
        setHasEditPermission(true);
      }

      const newConsentDetail: ConsentDetailsType = {
        ...consentData,
        status: statusCheck,
        signedDate: resultSigned,
        requestedDate: resultUpdateRequested,
        requester: {
          name: 'Thom',
          email: consentData.programDetails.email
            ? consentData.programDetails.email
            : '',
          phone: consentData.programDetails.phoneNumber
            ? consentData.programDetails.phoneNumber
            : '',
        },
        signature: resultSignature,
        summary: consentData.summary,
        description: consentData.description,
        othersComment: consentData.othersComment,
        consentInsurance: consentData.consentInsurance ?? {
          companyId: null,
          companyName: null,
          otherCompanyName: null,
          policyNumber: null,
          subscriberName: null,
          consentToInsurance: '',
          insuranceNotes: '',
          isInsuranceMigrated: false,
        },
        revokeSignature: consentData.revokeSignature,
      };
      setConsentDetails(newConsentDetail);
      setConsentBackupDetails(structuredClone(newConsentDetail));

      setLanguage(consentData.selectedLanguage);
      setOtherContactName(consentData.otherContactName);
      setOtherInitialContactName(consentData.otherContactName);
      setOthersChecked([{ checked: consentData.other }]);
      setChecked(consentData.refusal);
      setSelectedClient({
        name: consentData.client.name,
        dob: consentData.client.dob,
        dphId: consentData.client.dphId ? consentData.client.dphId : '',
        address: consentData.client.address ? consentData.client.address : '',
        gender: consentData.client.gender,
      });
      getContacts(consentData.contact);

      if (
        consentData.selectedContact !== null &&
        consentData.selectedContact.length > 0
      ) {
        const objectsArray: OptionType[] = consentData.selectedContact.map(
          (id: number | string) => ({
            id: id.toString(),
            label: '',
          }),
        );
        onSelectContact(objectsArray);
      }
    }
  }, [consentData]);

  const getDateFormatedValue = (locationDate: string | null) => {
    let originalDate: string;
    if (locationDate) {
      const currentUtcDate = new Date(locationDate);
      currentUtcDate.setUTCFullYear(currentUtcDate.getUTCFullYear() + 1);

      originalDate = currentUtcDate.toISOString();
      return originalDate;
    }
  };

  const setViews = (type: string) => {
    if (consentData && selectedVersion)
      switch (type) {
        case 'GRI': {
          setTitleTextInfo('ConsentGRI.TitleText');
          getRenderViews(ConsentGRI);
          setConsentName('General Release of Information');
          break;
        }
        case 'Assessment': {
          setTitleTextInfo('ConsentEvaOrAssessment.TitleText');
          getRenderViews(ConsentAssessment);
          setConsentName('Consent for Evaluation / Assessment');

          setInterventionCheckBoxView(consentInterventionCheckBox);
          const assessmentinputIndices = consentData.programProposes ?? [];
          const assessmentoutputArray = Array.from(
            { length: consentInterventionCheckBox.length },
            (__, index) => assessmentinputIndices?.includes(index),
          );

          setInterventionChecked(
            assessmentoutputArray.map((value) => ({ checked: value })),
          );
          break;
        }
        case 'Telehealth': {
          setTitleTextInfo('ConsentTelehealth.TitleText');
          getRenderViews(ConsentTelehealth);
          setConsentName('Consent for Telehealth');
          break;
        }
        case 'SavingsAcc': {
          if (consentDataJSON?.hsaConsentVersion === 1) {
            setTitleTextInfo('ConsentSavingsAcc.TitleText');
            setConsentName('Health Savings Account Alert');
          } else {
            setTitleTextInfo('ConsentSavingsAccHSA2.TitleText');
            setConsentName(
              'Health Savings Account (HSA) / Flexible Spending Account (FSA) Acknowledgment',
            );
          }
          getRenderViews(ConsentSavingsAcc);

          if (consentDataJSON?.hsaConsentVersion === 1) {
            const savingsAccBlock = (ConsentSavingsAcc as ConsentJson)[
              consentDataJSON?.uiVersion ?? 1
            ];
            setUnderstandingConcent(
              savingsAccBlock.UocTextOld ?? savingsAccBlock.UocText,
            );
          }

          const hsaCheckBox =
            consentDataJSON?.hsaConsentVersion === 1
              ? consentHSACheckBox
              : consentHSA2CheckBox;
          setInterventionCheckBoxView(hsaCheckBox);
          const HSAInputIndices = consentData.programProposes ?? [];

          const outputArray = Array.from(
            { length: hsaCheckBox.length },
            (__, index) => HSAInputIndices?.includes(index),
          );

          setInterventionChecked(
            outputArray.map((value) => ({ checked: value })),
          );
          break;
        }
        case 'SspShare':
          setTitleTextInfo('ConsentSspShare.TitleText');
          getRenderViews(ConsentSspShare);
          setConsentName('Consent to Share');
          break;
        case 'SspCommunicate': {
          setTitleTextInfo('ConsentSspCommunicate.TitleText');
          getRenderViews(ConsentSspCommunicate);
          setConsentName('SSP Consent to Communicate');

          const communicationoutputArray = consentData.communicationMode
            ? Array.from(
                { length: 3 },
                (__, index) =>
                  consentData.communicationMode !== null &&
                  consentData.communicationMode.includes(index),
              )
            : [false, false, false];

          setRequestedChecked(
            communicationoutputArray.map((value) => ({ checked: value })),
          );

          const purposeoutputArray = consentData.purpose
            ? Array.from(
                { length: 4 },
                (__, index) =>
                  consentData.purpose !== null &&
                  consentData.purpose.includes(index),
              )
            : [false, false, false, false];

          setPurposeChecked(
            purposeoutputArray.map((value) => ({ checked: value })),
          );
          break;
        }
        case 'CommunicateWithMedical': {
          setTitleTextInfo('ConsentCommunicateWithMedical.TitleText');
          getRenderViews(ConsentCommunicateWithMedical);
          setConsentName(
            'Consent to communicate with Medical Professionals using THOM Email',
          );
          break;
        }
        case 'CommunicateWithFamily': {
          setTitleTextInfo('ConsentCommunicateWithFamily.TitleText');
          getRenderViews(ConsentCommunicateWithFamily);
          setConsentName(
            'Consent to communicate with Family using THOM email and ThomConnect',
          );
          break;
        }
        case 'NoticeOfPrivacyPractices': {
          setTitleTextInfo('ConsentNoticeOfPrivacyPractices.TitleText');
          getRenderViews(ConsentNoticeOfPrivacyPractices);
          setConsentName('Notice of Privacy Practices');
          setNoppConsent(true);
          break;
        }
        case 'LegalReleaseofRecords': {
          setTitleTextInfo('ConsentLegalReleaseofRecords.TitleText');
          getRenderViews(ConsentLegalReleaseofRecords);
          setConsentName('Legal Release of Records');
          setLegalConsent(true);
          break;
        }
        case 'PriorWrittenNoticeForm': {
          setTitleTextInfo('ConsentPriorWrittenNoticeForm.TitleText');
          getRenderViews(ConsentPWN);
          setConsentName('Prior Written Notice Form (PWN)');
          setPwnForm(true);
          setIfspCheckBoxView(consentPWNIFSP);
          const PWNInputIndices = consentData?.ifsp;

          const outputArray = PWNInputIndices
            ? Array.from({ length: 4 }, (__, index) =>
                PWNInputIndices?.includes(index),
              )
            : [false, false, false, false];

          setInterventionPwnChecked(
            outputArray.map((value) => ({ checked: value })),
          );
          setEligibilityCheckBoxView(consentPWNIdentification);
          const PWNIdentityInputIndices: number[] =
            consentData.eligibility ?? [];

          const initialCheckedState: { checked: boolean }[] = Array.from(
            { length: 3 },
            (__, index) => ({
              checked: PWNIdentityInputIndices.includes(index),
            }),
          );

          setEligibilityPwnChecked(initialCheckedState);

          break;
        }
        case 'ConsentForChangeServiceDeliveryPlan': {
          setConsentForChange(true);
          setTitleTextInfo('ConsentForChangeServiceDeliveryPlan.TitleText');
          getRenderViews(ConsentForChangeServiceDeliveryPlan);
          setConsentName('IFSP Consent');
          break;
        }
        case 'InsuranceConsent': {
          setTitleTextInfo('InsuranceConsent');
          getRenderViews(ConsentInsuranceTemplate);
          setConsentName('Insurance Consent');
          setConsentInsurance(true);
          break;
        }
      }
  };

  const getRenderViews = (fileName: ConsentJson) => {
    const consentVersions = consentDataJSON?.uiVersion ?? 1;
    setProgramView(fileName[consentVersions].ProgramView);
    setExpiryDateView(fileName[consentVersions].ExpiryDateView);
    setClientView(fileName[consentVersions].ClientView);
    setReleaseClientView(fileName[consentVersions].ReleaseClientView);
    setInterventionView(fileName[consentVersions].InterventionView);
    setPwnTypeView(fileName[consentVersions].PWNType);
    setRequestedView(fileName[consentVersions].RequestedView);
    setUocView(fileName[consentVersions].UocView);
    setUorView(fileName[consentVersions].UorView);
    setSignatureView(fileName[consentVersions].SignatureView);
    setDisclaimerView(fileName[consentVersions].DisclaimerView);
    setDisclaimerTitleView(fileName[consentVersions].DisclaimerTitleView);
    setStaffInitialsView(fileName[consentVersions].StaffInitialsView);
    setSspData(fileName[consentVersions].PurposeText);
    setUnderstandingConcent(fileName[consentVersions].UocText);
    setDisclaimer(fileName[consentVersions].DisclaimerText);
    setIsVerbalConsentView(fileName[consentVersions].verbalConsent);
    setIsPaperConsentView(fileName[consentVersions].paperConsent);
  };

  const onSelectContact = (values: OptionType[] | OptionType | null) => {
    const filteredContacts: ConsentClientContact[] = [];
    if (Array.isArray(values)) {
      setDropDownValidationState(false);
      values.forEach((value) => {
        filteredContacts.push(...getContactInfo(value));
      });
    } else {
      filteredContacts.push(...getContactInfo(values));
    }
    setSelectedContact(filteredContacts);
  };

  const onRevokeSignatureSaveClick = (sign: string) => {
    const signedDate = dayjs().utc().format(LOCAL_DATE_TIME_UTC_FORMAT);
    const formatedDate = dayjs(signedDate).format(DATE_FORMAT);
    const revokedSignature = consentDetails.revokeSignature
      ? { ...consentDetails.revokeSignature, signature: sign }
      : consentDetails.revokeSignature;

    if (revokedSignature && !revokedSignature.consentSignedDate) {
      revokedSignature.consentSignedDate = formatedDate;
    }
    if (revokedSignature) {
      setConsentDetails({
        ...consentDetails,
        revokedDate: revokedSignature.consentSignedDate ?? formatedDate,
        revokeSignature: revokedSignature,
      });
    }
  };

  const onSaveClick = (sign: string, id: number) => {
    const signatureDate = moment().utc().format('YYYY-MM-DDTHH:mm:ss');

    setConsentDetails((prevConsentDetails) => {
      const updatedSignature = prevConsentDetails.signature.map(
        (item, index) => {
          if (index === id) {
            return {
              ...item,
              signature: sign,
              date: noppConsent || legalConsent ? signatureDate : '',
              partitionKey: '',
              rowKey: '',
            };
          }
          return item;
        },
      );

      return {
        ...prevConsentDetails,
        signature: updatedSignature,
      };
    });
  };

  const onRevokeConsentSignDateChange = (signedDate: string | null) => {
    const updatedRevokeSignature = consentDetails.revokeSignature
      ? { ...consentDetails.revokeSignature, consentSignedDate: signedDate }
      : consentDetails.revokeSignature;
    setConsentDetails({
      ...consentDetails,
      revokedDate: signedDate,
      revokeSignature: updatedRevokeSignature,
    });
  };

  const onConsentSignedDateChange = (
    consentSignedDate: string | null,
    id: number,
  ) => {
    setConsentDetails((prevConsentDetails) => {
      const updatedSignature = prevConsentDetails.signature.map(
        (item, index) => {
          if (index === id) {
            return {
              ...item,
              consentSignedDate: consentSignedDate,
            };
          }
          return item;
        },
      );

      const shouldClearRevokeDate =
        consentSignedDate &&
        prevConsentDetails.revokeSignature &&
        (!prevConsentDetails.revokeSignature.consentSignedDate ||
          dayjs(consentSignedDate).isAfter(
            dayjs(prevConsentDetails.revokeSignature.consentSignedDate),
          ));

      const updatedRevokeSignature =
        shouldClearRevokeDate && prevConsentDetails.revokeSignature
          ? { ...prevConsentDetails.revokeSignature, consentSignedDate: null }
          : prevConsentDetails.revokeSignature;

      return {
        ...prevConsentDetails,
        revokedDate: shouldClearRevokeDate
          ? null
          : prevConsentDetails.revokedDate,
        signedDate: consentSignedDate,
        signature: updatedSignature,
        revokeSignature: updatedRevokeSignature,
      };
    });
  };

  const onRevokeSignatureVerbalConsentClick = (value: boolean) => {
    const signedDate = dayjs().utc().format(LOCAL_DATE_TIME_UTC_FORMAT);
    const formatedDate = dayjs(signedDate).format(DATE_FORMAT);
    const updatedRevokeSignature = consentDetails.revokeSignature
      ? {
          ...consentDetails.revokeSignature,
          verbal: value,
          consentSignedDate:
            consentDetails.revokeSignature.consentSignedDate || formatedDate,
        }
      : consentDetails.revokeSignature;
    if (updatedRevokeSignature) {
      setConsentDetails({
        ...consentDetails,
        revokedDate: updatedRevokeSignature.consentSignedDate,
        revokeSignature: updatedRevokeSignature,
      });
    }
  };

  const onRevokeSignaturePaperConsentClick = (value: boolean) => {
    const signedDate = dayjs().utc().format(LOCAL_DATE_TIME_UTC_FORMAT);
    const formatedDate = dayjs(signedDate).format(DATE_FORMAT);
    const updatedRevokeSignature = consentDetails.revokeSignature
      ? {
          ...consentDetails.revokeSignature,
          paperConsent: value,

          consentSignedDate:
            consentDetails.revokeSignature.consentSignedDate || formatedDate,
        }
      : consentDetails.revokeSignature;
    if (updatedRevokeSignature) {
      setConsentDetails({
        ...consentDetails,
        revokedDate: updatedRevokeSignature.consentSignedDate,
        revokeSignature: updatedRevokeSignature,
      });
    }
  };

  const onVerbalConsentClick = (value: boolean, index: number) => {
    const signatureDate = moment().utc().format('YYYY-MM-DDTHH:mm:ss');

    setConsentDetails((prevConsentDetails) => {
      const updatedSignature = prevConsentDetails.signature.map((item, id) => {
        if (id === index) {
          return {
            ...item,
            verbal: value,
            date: noppConsent || legalConsent ? signatureDate : '',
          };
        }
        return item;
      });

      return {
        ...prevConsentDetails,
        signature: updatedSignature,
      };
    });
  };
  const onPaperConsentClick = (value: boolean, index: number) => {
    const signatureDate = moment().utc().format('YYYY-MM-DDTHH:mm:ss');

    setConsentDetails((prevConsentDetails) => {
      const updatedSignature = prevConsentDetails.signature.map((item, id) => {
        if (id === index) {
          return {
            ...item,
            paperConsent: value,
            date: noppConsent || legalConsent ? signatureDate : '',
          };
        }
        return item;
      });

      return {
        ...prevConsentDetails,
        signature: updatedSignature,
      };
    });
  };

  const handleSave = () => {
    const consentSignedDateValidation = consentDetails.signature.some((s) =>
      datePickerMinDateMaxDateValidate(s.consentSignedDate),
    );

    if (!pwnForm) {
      const revokeValidation =
        checked && consentDetails.revokeSignature?.name === '';
      if (revokeValidation) return;

      const resultStatus =
        !consentDetails.refusal &&
        consentDetails.signature.some((s) => {
          if (s.name === '') return false;

          if (
            (s.verbal && isVerbalConsentView) ||
            (s.paperConsent && isPaperConsentView) ||
            s.signature !== '' ||
            s.rowKey !== ''
          )
            return false;

          return true;
        });
      if (resultStatus) {
        setOpen(true);
        setToastrVariable('error');
        setToastrId('ConsentForms.signatureToasterError');
        setToastrDefaultMessage(
          'Guardian Signature / Verbal Consent is mandatory',
        );
        return;
      }
    }

    if (
      consentDetails.type === 'InsuranceConsent' &&
      consentDetails.consentInsurance
    ) {
      if (
        !consentDetails.consentInsurance.consentToInsurance &&
        consentDetails.signature.some(
          (s) =>
            s.name !== '' &&
            ((s.verbal && isVerbalConsentView) ||
              (s.paperConsent && isPaperConsentView) ||
              s.signature !== '' ||
              s.rowKey !== ''),
        )
      ) {
        setOpen(true);
        setToastrVariable('error');
        setToastrDefaultMessage(
          'Please select one of the consent options: Access Insurance, Uninsured, or Refusal to Access Insurance Form.',
        );
        setToastrId('ConsentForms.accessToInsuranceIsRequired');
        return;
      }
      if (
        consentDetails.consentInsurance.consentToInsurance === 'authorize' &&
        (!consentDetails.consentInsurance.companyId ||
          consentDetails.consentInsurance.companyId === '')
      ) {
        setOpen(true);
        setToastrVariable('error');
        setToastrDefaultMessage(
          '3rd Party Payer (Insurance Name) is required when Access Insurance is selected',
        );
        setToastrId('ConsentForms.insuranceNameIsRequired');
        return;
      }
      if (
        consentDetails.consentInsurance.companyId === 'backend-others' &&
        consentDetails.consentInsurance.otherCompanyName === null
      ) {
        setOpen(true);
        setToastrVariable('error');
        setToastrDefaultMessage('Other Company Name is required');
        setToastrId('ConsentForms.otherCompanyNameIsRequired');
        return;
      }
    }

    if (consentDetails.refusal && !revokeGuardian) {
      setOpen(true);
      setToastrVariable('error');
      setToastrDefaultMessage('Revoking consent require guardian signature');
      setToastrId('revokeGuardianNameRequired');
      return;
    }

    if (consentDetails.refusal && consentDetails.revokeSignature) {
      const signature = consentDetails.revokeSignature;
      if (
        ((!signature.verbal && isVerbalConsentView) ||
          (!signature.paperConsent && isPaperConsentView)) &&
        signature.signature === '' &&
        (!signature.rowKey || signature.rowKey === '')
      ) {
        setOpen(true);
        setToastrVariable('error');
        setToastrDefaultMessage('Revoking consent require guardian signature');
        setToastrId('revokeGuardianNameRequired');
        return;
      }
    }

    if (
      consentDetails.refusal &&
      dayjs(consentDetails.revokedDate).isBefore(
        dayjs(consentDetails.signedDate).format(DATE_FORMAT),
      )
    ) {
      setOpen(true);
      setToastrVariable('error');
      setToastrDefaultMessage('Refusal Date cannot be before Consent Date');
      setToastrId('ConsentForms.refusalDateCannotBeBeforeToday');
      return;
    }

    if (datePickerMinDateMaxDateValidate(consentDetails.revokedDate)) {
      setOpen(true);
      setToastrVariable('error');
      setToastrDefaultMessage(
        'Enter a Refusal date between 01/01/1900 and 01/01/2100',
      );
      setToastrId('consentInsuranceInvalidRefusalDateMessage');
      return;
    }
    if (datePickerMinDateMaxDateValidate(consentDetails.dateMailed)) {
      setOpen(true);
      setToastrVariable('error');
      setToastrDefaultMessage('Mailed Date is invalid');
      setToastrId('datePickerMinDateMaxDateValidate');
      return;
    } else if (consentSignedDateValidation) {
      setOpen(true);
      setToastrVariable('error');
      setToastrDefaultMessage('Signed Date is invalid');
      setToastrId('datePickerMinDateMaxDateValidate');
      return;
    }

    if (consentDetails.refusal && !consentDetails.revokedDate) {
      setOpen(true);
      setToastrVariable('error');
      setToastrDefaultMessage('Revoke Date is required for Consent form');
      setToastrId('ConsentForms.revokeDateRequired');
      return;
    }

    if (pwnForm && consentDetails.initials && !consentDetails.dateMailed) {
      setOpen(true);
      setToastrVariable('error');
      setToastrDefaultMessage('Maild Date is Required');
      setToastrId('ConsentForms.maildDateIsRequired');
      return;
    } else if (pwnForm && !consentDetails.consentPwnType.id) {
      setOpen(true);
      setToastrVariable('error');
      setToastrDefaultMessage('Prior Written Notice Type is Required');
      setToastrId('ConsentForms.priorWrittenNoticeTypeIsRequired');
      return;
    } else if (
      pwnForm &&
      consentDetails.consentPwnType.id &&
      consentDetails.consentPwnType.id === 'P04' &&
      !consentDetails.consentPwnType.pwnDescription
    ) {
      setOpen(true);
      setToastrVariable('error');
      setToastrDefaultMessage(
        'Prior Written Notice Type Description is Required',
      );
      setToastrId('ConsentForms.priorWrittenNoticeTypeDescriptionIsRequired');
      return;
    } else if (
      !pwnForm &&
      (consentDetails.signature[0].rowKey ||
        consentDetails.signature[0].signature ||
        (consentDetails.signature[0].verbal && isVerbalConsentView) ||
        (consentDetails.signature[0].paperConsent && isPaperConsentView)) &&
      (!consentDetails.signature[0].consentSignedDate ||
        !dayjs(consentDetails.signature[0].consentSignedDate).isValid())
    ) {
      setOpen(true);
      setToastrVariable('error');
      setToastrDefaultMessage('Consent date is Required');
      setToastrId('ConsentForms.consentDateIsRequired');
      return;
    }
    const updatedSignature = consentDetails.signature.map((item) => ({
      ...item,
      date:
        (noppConsent || legalConsent) &&
        (item.signature !== '' ||
          (item.verbal && isVerbalConsentView) ||
          (item.paperConsent && isPaperConsentView))
          ? item.date
          : '',
    }));

    let checkValidation = false;
    if (
      consentData &&
      selectedContact.length > 0 &&
      !excludedTypes.includes(consentData.type)
    ) {
      consentDetails.contact.forEach((contact: ConsentClientContact) => {
        if (
          selectedContact.some((selected) => selected.id === contact.id) &&
          contact.type === 'Other' &&
          otherContactName === ''
        ) {
          checkValidation = true;
        }
      });

      if (checkValidation) {
        setDropDownOtherContactValidationState(true);
      }
    } else {
      setDropDownValidationState(true);
    }

    if (
      (consentData && excludedTypes.includes(consentData.type)) ||
      (!checkValidation && selectedContact.length > 0)
    ) {
      toggleLoader(true);
      callAPIToSaveConsent(updatedSignature);
    }
  };

  const callAPIToSaveConsent = (updatedSignature: ConsentClientSignature[]) => {
    let signedDate: string | Date = '';
    if (
      consentDetails.signature.length > 0 &&
      consentDetails.signature.some(
        (item) =>
          item.signature !== '' ||
          (item.verbal && isVerbalConsentView) ||
          (item.paperConsent && isPaperConsentView) ||
          item.rowKey !== '',
      ) &&
      !pwnForm
    ) {
      consentDetails.signature.forEach((item) => {
        if (
          item.signature !== '' ||
          (item.verbal && isVerbalConsentView) ||
          (item.paperConsent && isPaperConsentView) ||
          item.rowKey !== ''
        ) {
          signedDate =
            dayjs(consentDetails.signature[0].consentSignedDate, DATE_FORMAT)
              .hour(dayjs().hour())
              .minute(dayjs().minute())
              .second(dayjs().second())
              .millisecond(dayjs().millisecond())
              .toISOString() ?? '';
        }
      });
    } else if (pwnForm && consentDetails.dateMailed) {
      signedDate =
        dayjs(consentDetails.dateMailed, DATE_FORMAT)
          .hour(dayjs().hour())
          .minute(dayjs().minute())
          .second(dayjs().second())
          .millisecond(dayjs().millisecond())
          .toISOString() ?? '';
    }

    let revokedDateValue = '';

    if (consentDetails.refusal) {
      revokedDateValue = consentDetails.revokedDate
        ? dayjs(consentDetails.revokedDate, DATE_FORMAT)
            .hour(dayjs().hour())
            .minute(dayjs().minute())
            .second(dayjs().second())
            .millisecond(dayjs().millisecond())
            .toISOString()
        : '';
    }

    const params: ConsentDetailsType = {
      type: consentDetails.type,
      name: consentName,
      consentId: consentDetails.consentId,
      version: selectedVersion,
      signedDate: signedDate,
      revokedDate: revokedDateValue,
      status: consentDetails.status,
      requestedDate: consentDetails.requestedDate,
      requester: {
        name: consentDetails.requester.name,
        email: consentDetails.requester.email,
        phone: consentDetails.requester.phone,
      },
      client: {
        id: consentDetails.client.id,
        name: consentDetails.client.name,
        dphId: consentDetails.client.dphId,
        gender: consentDetails.client.gender,
        dob: consentDetails.client.dob,
        address: consentDetails.client.address,
      },
      selectedContact: selectedContact
        ? selectedContact.map((item) => item.id)
        : [],
      contact: consentDetails.contact,
      refusal: consentDetails.refusal,
      signature: updatedSignature,
      programProposes: consentDetails.programProposes,
      communicationMode: consentDetails.communicationMode,
      purpose: consentDetails.purpose,
      programDetails: consentDetails.programDetails,
      ifsp: consentDetails.ifsp,
      serviceDeliveryPlan: {
        agreeDisagree: consentDetails.serviceDeliveryPlan.agreeDisagree,
        assessmentCompletionDate:
          consentDetails.serviceDeliveryPlan.assessmentCompletionDate === '' ||
          consentDetails.serviceDeliveryPlan.assessmentCompletionDate === null
            ? dayjs().format(DATE_FORMAT)
            : consentDetails.serviceDeliveryPlan.assessmentCompletionDate,

        consent: consentDetails.serviceDeliveryPlan.consent,
        eligibleTool: consentDetails.serviceDeliveryPlan.eligibleTool,
        exceptionList: consentDetails.serviceDeliveryPlan.exceptionList,
        isChecked: consentDetails.serviceDeliveryPlan.isChecked,
        isEligibleUntilThirdBirthday:
          consentDetails.serviceDeliveryPlan.isEligibleUntilThirdBirthday,
        parentInitial: consentDetails.serviceDeliveryPlan.parentInitial,
        participated: consentDetails.serviceDeliveryPlan.participated,
        reEstablishedDate:
          consentDetails.serviceDeliveryPlan.reEstablishedDate === '' ||
          consentDetails.serviceDeliveryPlan.reEstablishedDate === null
            ? dayjs().format(DATE_FORMAT)
            : consentDetails.serviceDeliveryPlan.reEstablishedDate,
      },
      eligibility: consentDetails.eligibility,
      other: consentDetails.other,
      otherContactName: otherContactName || '',
      othersComment: consentDetails.othersComment,
      summary: consentDetails.summary,
      description: consentDetails.description,
      selectedLanguage: selectedLanguageValue,
      uiVersion: consentDetails.uiVersion,
      hsaConsentVersion: consentDetails.hsaConsentVersion,
      dateMailed: consentDetails.dateMailed,
      initials: consentDetails.initials,
      consentPwnType: consentDetails.consentPwnType,
      consentInsurance: consentDetails.consentInsurance
        ? {
            companyId: consentDetails.consentInsurance.companyId,
            companyName: consentDetails.consentInsurance.companyName,
            otherCompanyName: consentDetails.consentInsurance.otherCompanyName,
            policyNumber: consentDetails.consentInsurance.policyNumber,
            subscriberName: consentDetails.consentInsurance.subscriberName,
            consentToInsurance:
              consentDetails.consentInsurance.consentToInsurance,
            insuranceNotes: consentDetails.consentInsurance.insuranceNotes,
            isInsuranceMigrated:
              consentDetails.consentInsurance.isInsuranceMigrated,
          }
        : {
            companyId: null,
            companyName: null,
            otherCompanyName: null,
            policyNumber: null,
            subscriberName: null,
            consentToInsurance: '',
            insuranceNotes: '',
            isInsuranceMigrated: false,
          },
      revokeSignature: consentDetails.revokeSignature,
    };
    submitAPI(params);
  };

  const submitAPI = useCallback(
    debounce((params: ConsentDetailsType) => {
      handleSubmit(params);
    }, 1000),
    [],
  );

  const handleSubmit = (params: ConsentDetailsType) => {
    toggleLoader(true);

    updateConsent(params.type, params.consentId, params, selectedVersionNo)
      .then((response) => {
        if (response) {
          setOpen(true);
          setToastrVariable('success');
          setToastrId('ConsentForms.submitToaster');
          setToastrDefaultMessage('Consent Form Successfully Saved.');
          setBtnName(true);
          setTimeout(() => {
            toggleLoader(false);
            localStorage.removeItem('consentDataJSON');
            localStorage.removeItem('selectedVersionNo');
            navigate(CONSENT_DASHBOARD);
          }, 1000);
        }
      })
      .catch((error) => {
        setOpen(true);
        toggleLoader(false);
        setToastrVariable('error');
        if (isCustomError(error)) {
          const apiError = error as ApiError;
          setToastrId(apiError.id);
          setToastrDefaultMessage(apiError.message);
        } else {
          setToastrId('ConsentForms.concentUpdateError');
          setToastrDefaultMessage('Failed to update Consent details');
        }
      });
  };

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const handleClear = () => {
    localStorage.removeItem('consentDataJSON');
    localStorage.removeItem('selectedVersionNo');
    navigate(CONSENT_DASHBOARD);
  };

  const handleStatus = (statusValue: string) => {
    let validatedStatus = '';
    if (statusValue.toLowerCase().includes('revoked')) {
      const filterRevoked =
        consentData && consentDetails.revokedDate === ''
          ? consentData.revokedDate
          : consentDetails.revokedDate;

      validatedStatus = filterRevoked
        ? 'Revoked'.concat(
            ' (' +
              moment(dayjs(filterRevoked).toDate()).format(DATE_FORMAT) +
              ')',
          )
        : 'Revoked';
    } else {
      validatedStatus = statusValue;
    }

    return validatedStatus;
  };

  const handleContactOtherName = (value: string) => {
    setDropDownOtherContactValidationState(false);
    setOtherContactName(value);
  };

  const isFormUnchanged = () => {
    const extractedId = selectedContact.map((d) => d.id);

    const areIdsEqual =
      initialSelectedContactId.length === extractedId.length &&
      initialSelectedContactId.every((id) => extractedId.includes(id));

    return (
      _.isEqual(consentBackupDetails, consentDetails) &&
      _.isEqual(otherInitialContactName, otherContactName) &&
      areIdsEqual
    );
  };

  const getConsentMinimumDate = (): dayjs.Dayjs | undefined => {
    const signatureWithDate = consentDetails.signature.find(
      (s) => s.consentSignedDate && s.consentSignedDate !== '',
    );
    if (signatureWithDate) {
      return dayjs(signatureWithDate.consentSignedDate);
    }
    if (consentDetails.signedDate && consentDetails.signedDate !== '') {
      return dayjs(consentDetails.signedDate);
    }
    return undefined;
  };

  const isConsentSigned = () => {
    return (
      !consentData?.signedDate &&
      consentDetails.signature.some(
        (s) =>
          s.name !== '' ||
          s.signature !== '' ||
          s.rowKey !== '' ||
          (s.verbal && isVerbalConsentView) ||
          (s.paperConsent && isPaperConsentView),
      )
    );
  };

  const checkedGuardianRequired = () => {
    if (
      consentDetails?.type === 'InsuranceConsent' &&
      consentDetails.consentInsurance?.isInsuranceMigrated
    ) {
      return false;
    }
    return checked;
  };

  return (
    <Box component="div">
      <SnackBarComponent
        open={open}
        handleClose={handleClose}
        successOrError={toastrVariable}
        labelId={toastrId}
        defaultMessageId={toastrDefaultMessage}
      />
      <ModalPopup
        description="formUnsavedChangesMessage"
        open={openModal}
        onCancel={() => {
          setOpenModal(false);
        }}
        onOk={() => {
          handleClear();
          setOpenModal(false);
        }}
        labelId1="Clientpage.Nobtn"
        negativeActionLabel="No"
        labelId2="Clientpage.Yesbtn"
        positiveActionLabel="Yes"
      />
      <TranslateWidget
        screenId={translationId.current}
        initialLanguage={'en'}
        languageChangeCallback={(lang) => {
          setSelectedLanguageValue(lang);
        }}
      >
        {consentDetails && (
          <Box component="div">
            <Box component="main">
              <Box component="section">
                {!pwnForm && (
                  <Box component="div" className="rowContainer">
                    <Grid container>
                      <Grid item xs={12} lg={12}>
                        <Box className="flex__  align__items__center">
                          <CustomBackArrow
                            onClick={() => {
                              if (isFormUnchanged()) {
                                setOpenModal(false);
                                localStorage.removeItem('consentDataJSON');
                                localStorage.removeItem('selectedVersionNo');
                                navigate(CONSENT_DASHBOARD);
                              } else {
                                setOpenModal(true); // This should always trigger on first mismatch
                              }
                            }}
                          />
                          <TitleText
                            className="flex__ pl-md"
                            labelid={titleTextInfo}
                            defaultlabel="General Release of Information"
                          />
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                )}

                {pwnForm && (
                  <Box component="div" className="rowContainer">
                    <Grid container>
                      <Grid item xs={6} lg={6}>
                        <Box className="flex__  align__items__center">
                          <CustomBackArrow
                            onClick={() => {
                              if (
                                _.isEqual(consentBackupDetails, consentDetails)
                              ) {
                                setOpenModal(false);
                                localStorage.removeItem('consentDataJSON');
                                localStorage.removeItem('selectedVersionNo');
                                navigate(CONSENT_DASHBOARD);
                              } else {
                                setOpenModal(true);
                              }
                            }}
                          />
                          <TitleText
                            className="flex__ pl-md"
                            labelid={titleTextInfo}
                            defaultlabel="General Release of Information"
                          />
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                )}
                <Box>
                  <Card className="formCardview pt-sm">
                    <Box
                      style={{
                        pointerEvents:
                          hasEditPermission && isAuthorized ? 'auto' : 'none',
                        opacity:
                          hasEditPermission && isAuthorized ? 'unset' : '0.8',
                      }}
                    >
                      {consentDetails.programDetails && (
                        <ProgramPanel
                          program={consentDetails.programDetails}
                          showDHPLogo={false}
                        />
                      )}
                      <SingleLine className="width__100 mt-sm mb-sm" />
                      {programView && (
                        <Box component="div">
                          <ConsentGeneralInfo
                            consentDatePlaceholder={'ConsentForms.signedDate'}
                            consentDateDefaultPlaceholder={'Consent Date:'}
                            expiryDatePlaceholder={'ConsentForms.revokedDate'}
                            expiryDateDefaultPlaceholder={'Expiry Date:'}
                            status={handleStatus(consentDetails.status)}
                            signedDate={
                              consentDetails.signedDate
                                ? moment(consentDetails.signedDate)
                                    .local()
                                    .format(DATE_FORMAT)
                                : ''
                            }
                            expiredDate={getExpiredDate()}
                            statusLabelId={'ConsentForms.status'}
                            statusDefaultLabelId={'Authorization Status:'}
                            expireDateView={expiryDateView}
                          />
                          <SingleLine className="width__100 mt-sm mb-sm" />
                        </Box>
                      )}
                      {clientView && (
                        <Box component="div">
                          <ConsentClientDetails
                            titleLabel={'ConsentForms.clientTitle'}
                            defaultTitleLabel="Client Details"
                            clients={selectedClient}
                            dphIdLabel={'ConsentForms.clientDPHID'}
                            dphIddefaultLabel={'Enrollment ID:'}
                            dobLabel={'ConsentForms.clientDob'}
                            dobDefaultLabel={'Date of Birth:'}
                            genderLabel={'ConsentForms.clientGender'}
                            genderDefaultLabel={'Sex:'}
                            addressLabel={'ConsentForms.clientAddress'}
                            addressDefaultLabel={'Address:'}
                          />
                          <SingleLine className="width__100 mt-sm mb-sm" />
                        </Box>
                      )}
                      {requestedView && (
                        <Box component="div">
                          <Box className="pt-sm pb-md">
                            <ConsentFormTextWithCheckbox
                              data={sspData[0].communication}
                              titleLabel="ConsentForms.communicationPurposeTitle"
                              defaultTitleLabel="Requested by"
                              value={requestedChecked}
                              onClickChange={onRequestedChecked}
                              inline={true}
                            />
                          </Box>
                          <SingleLine className="width__100 mt-sm mb-sm" />
                          <Box className="pt-sm pb-md">
                            <ConsentFormTextWithCheckbox
                              data={sspData[0].purpose}
                              titleLabel="ConsentForms.ConsentSspCommunicate.purposeTitle"
                              defaultTitleLabel="For the purpose of"
                              value={purposeChecked}
                              onClickChange={onPurposeChecked}
                              inline={true}
                            />
                          </Box>
                          <SingleLine className="width__100 mt-sm mb-sm" />
                        </Box>
                      )}
                      {releaseClientView && (
                        <Box component="div">
                          <ConsentSspAgencyDetails
                            contacts={selectedContact}
                            titleLabel={getConsentTitleLabel()}
                            defaultTitleLabel={getConsentDefaultTitleLabel()}
                            searchContactLabel={
                              consentDetails.type === 'GRI'
                                ? 'ConsentForms.labelPermissionWithGRI'
                                : 'ConsentForms.labelPermissionTo'
                            }
                            defaultSearchContactLabel={
                              consentDetails.type === 'GRI'
                                ? 'Permission Granted with'
                                : 'Permission Granted to'
                            }
                            contactData={contacts}
                            onSelect={onSelectContact}
                            emailLabelId={'ConsentForms.contactEmail'}
                            emailDefaultLabelId={'Email:'}
                            addressLabelId={'ConsentForms.contactAddress'}
                            addressDefaultLabelId={'Address:'}
                            phoneLabelId={'ConsentForms.contactPhone'}
                            phoneDefaultLabelId={'Phone:'}
                            contactOtherName={otherContactName || ''}
                            handleContactOtherName={handleContactOtherName}
                            dropDownValidation={dropDownValidationState}
                            dropDownOtherContactValidationState={
                              dropDownOtherContactValidationState
                            }
                            screenLocked={!hasEditPermission || !isAuthorized}
                          />
                          <SingleLine className="width__100 mt-sm mb-sm" />
                        </Box>
                      )}

                      {/* {consentDetails.type === 'GRI' && (
                        <Box component="div">
                          <SingleLine className="width__100 mt-sm mb-sm" />
                        </Box>
                      )} */}

                      {interventionView && !pwnForm && (
                        <Box component="div">
                          <Box className="pt-sm pb-md">
                            <ConsentFormTextWithCheckbox
                              data={interventionCheckBoxView}
                              titleLabel={
                                consentDetails.type === 'SavingsAcc' &&
                                consentDataJSON?.hsaConsentVersion === 2
                                  ? 'ConsentFormsHSA2.purposeTitle'
                                  : 'ConsentForms.purposeTitle'
                              }
                              defaultTitleLabel={
                                consentDetails.type === 'SavingsAcc' &&
                                consentDataJSON?.hsaConsentVersion === 2
                                  ? 'Please indicate whether you or your family participates in any of the following:'
                                  : 'The early intervention program proposes to complete'
                              }
                              value={interventionChecked}
                              onClickChange={onInterventionChecked}
                              inline={false}
                            />
                          </Box>
                          <SingleLine className="width__100 mt-sm mb-sm" />
                        </Box>
                      )}
                      {uocView && (
                        <Box component="div">
                          <MediumTypography
                            fontSize="18px"
                            fontweight={600}
                            textColor="#2A4241"
                            labelid={getLabelId()}
                            defaultlabel={
                              legalConsent
                                ? 'Information Regarding Legal Release of Child Records'
                                : noppConsent
                                ? 'Notice of Privacy Practices For Children and Parents Receiving Services Through the Early Intervention Program'
                                : pwnForm
                                ? 'Prior Written Notice form'
                                : 'Understanding of Consent'
                            }
                            className="pb-sm pt-md"
                          />
                          <Typography
                            dangerouslySetInnerHTML={{
                              __html: understandingConcent,
                            }}
                            sx={{
                              fontFamily: 'Lato-Regular',
                              fontSize: '14px',
                              fontWeight: 400,
                            }}
                          />
                          <SingleLine className="width__100 mt-sm mb-sm" />
                          {consentDetails.type === 'SavingsAcc' &&
                            consentDataJSON?.hsaConsentVersion === 2 && (
                              <Box component="div">
                                <MediumTypography
                                  fontSize="18px"
                                  fontweight={600}
                                  textColor="#2A4241"
                                  labelid="ConsentSavingsAcc2.acknowledgmentTitle"
                                  defaultlabel="Parent/Guardian Acknowledgment"
                                  className="pb-sm pt-md"
                                />
                                <MediumTypography
                                  fontSize="14px"
                                  textColor="#2A4241"
                                  labelid="ConsentSavingsAcc2.acknowledgmentText"
                                  defaultlabel="If I have a Health Savings Account (HSA) or Flexible Spending Account (FSA), I understand that it is my responsibility to contact my health insurance company to notify them not to access or apply funds from my HSA or FSA for Early Intervention Services. I understand that any questions regarding the administration of my HSA or FSA should be directed to my health insurance company or benefits administrator."
                                />
                                <SingleLine className="width__100 mt-sm mb-sm" />
                              </Box>
                            )}
                        </Box>
                      )}
                      {pwnForm && pwnTypeView && (
                        <Box component="div" sx={{ width: '30%' }}>
                          <MediumTypography
                            fontSize="18px"
                            fontweight={600}
                            textColor="#2A4241"
                            labelid="ConsentForms.pwnTitle"
                            defaultlabel="Prior Written Notice Type"
                            className="pb-md pt-md"
                          />
                          <DropdownComponent
                            names={pwnTypeLookup}
                            value={consentDetails.consentPwnType.id ?? ''}
                            handleChange={(val) => {
                              if (val) {
                                setConsentDetails({
                                  ...consentDetails,
                                  consentPwnType: {
                                    id: val,
                                    pwnType: getPwnTypeLabel(val),
                                    pwnDescription: null,
                                  },
                                });
                              } else {
                                setConsentDetails({
                                  ...consentDetails,
                                  consentPwnType: {
                                    id: null,
                                    pwnType: null,
                                    pwnDescription: null,
                                  },
                                });
                              }
                            }}
                            labelid="ConsentForms.pwnType"
                            defaultlabelid="Type"
                            Required={true}
                          />
                          {consentDetails.consentPwnType.id === 'P04' && (
                            <Box className="mt-md">
                              <Textinput
                                className="mt-sm"
                                labelid={'description'}
                                defaultlabelid={'Description'}
                                inputProps={{ maxLength: 20 }}
                                handlechange={(value) => {
                                  setConsentDetails({
                                    ...consentDetails,
                                    consentPwnType: {
                                      ...consentDetails.consentPwnType,
                                      pwnDescription: value,
                                    },
                                  });
                                }}
                                Value={
                                  consentDetails.consentPwnType
                                    .pwnDescription ?? ''
                                }
                                disabled={!hasEditPermission || !isAuthorized}
                                Required
                              />
                            </Box>
                          )}
                        </Box>
                      )}
                      {interventionView && pwnForm && (
                        <Box component="div">
                          <Box className="pt-sm pb-md">
                            <ConsentFormTextWithCheckbox
                              data={eligibilityCheckBoxView}
                              titleLabel={'ConsentForms.pwnPurposeTitle'}
                              defaultTitleLabel={
                                'The activity or action requiring written notice (check all that apply)'
                              }
                              inline={false}
                              subTitleLabel="ConsentForms.pwnPurposeSubTitle1"
                              defaultSubTitleLabel="Eligibility / Identification"
                              subTitleRequired={true}
                              onClickChange={onEligibilityPwnChecked}
                              value={eligibilityPwnChecked}
                            />
                            <ConsentFormTextWithCheckbox
                              data={ifspCheckBoxView}
                              value={interventionPwnChecked}
                              onClickChange={onIFSPPwnChecked}
                              inline={false}
                              subTitleLabel="ConsentForms.pwnPurposeSubTitle2"
                              defaultSubTitleLabel="IFSP Meeting / IFSP services:"
                              subTitleRequired={true}
                            />
                          </Box>
                          <SingleLine className="width__100 mt-sm mb-sm" />
                          <Box className="pt-sm pb-md">
                            <ConsentFormTextWithCheckbox
                              data={consentFormPwnOthers}
                              titleLabel={'ConsentForms.pwnOthersTitle'}
                              defaultTitleLabel={'Others(describe):'}
                              inline={false}
                              onClickChange={onOthersChecked}
                              value={othersChecked}
                            />
                            {othersChecked.some((item) => item.checked) && (
                              <Box className="mt-md">
                                <CommentTextbox
                                  name="othersComment"
                                  className="translate"
                                  placeholder={'Enter the description here'}
                                  rows={5}
                                  maxLength={3000}
                                  Value={consentDetails.othersComment}
                                  handlechange={(value) => {
                                    setConsentDetails({
                                      ...consentDetails,
                                      othersComment: value,
                                    });
                                  }}
                                />
                              </Box>
                            )}
                          </Box>
                          <SingleLine className="width__100 mt-sm mb-sm" />
                        </Box>
                      )}

                      {consentInsurance && (
                        <Box>
                          <ConsentInsuranceDetails
                            insuranceLookup={insuranceLookup}
                            hasEditPermission={
                              hasEditPermission && isAuthorized
                            }
                            consentInsurance={{
                              companyId: consentDetails.consentInsurance
                                ? consentDetails.consentInsurance.companyId
                                : null,
                              companyName: consentDetails.consentInsurance
                                ? consentDetails.consentInsurance.companyName
                                : null,
                              otherCompanyName: consentDetails.consentInsurance
                                ? consentDetails.consentInsurance
                                    .otherCompanyName
                                : null,
                              policyNumber: consentDetails.consentInsurance
                                ? consentDetails.consentInsurance.policyNumber
                                : null,
                              subscriberName: consentDetails.consentInsurance
                                ? consentDetails.consentInsurance.subscriberName
                                : null,
                              consentToInsurance:
                                consentDetails.consentInsurance
                                  ? consentDetails.consentInsurance
                                      .consentToInsurance
                                  : '',
                              insuranceNotes: consentDetails.consentInsurance
                                ? consentDetails.consentInsurance.insuranceNotes
                                : '',
                              isInsuranceMigrated:
                                consentDetails.consentInsurance
                                  ? consentDetails.consentInsurance
                                      .isInsuranceMigrated
                                  : false,
                            }}
                            updateConsentInsurance={(
                              consent: ConsentInsurance,
                            ) => {
                              setConsentDetails({
                                ...consentDetails,
                                consentInsurance: consent,
                              });
                            }}
                          />
                        </Box>
                      )}

                      {pwnForm && (
                        <Box component="div">
                          <Box className="pt-xs pb-md">
                            <MediumTypography
                              labelid="ConsentForms.PwnSummary"
                              defaultlabel="Summary of IFSP Team’s Discussion: What is being proposed or declined? Why is the activity being proposed or declined?"
                              fontSize="18px"
                              fontweight={600}
                              className="mt-md mb-md"
                            />
                            <CommentTextbox
                              name="summary"
                              className="translate"
                              placeholder={'Enter summary here'}
                              rows={5}
                              maxLength={3000}
                              Value={consentDetails.summary}
                              handlechange={(value) => {
                                setConsentDetails({
                                  ...consentDetails,
                                  summary: value,
                                });
                              }}
                            />
                            <MediumTypography
                              labelid="ConsentForms.PwnInfo"
                              defaultlabel="Describe the information used to make this decision (such as evaluation/assessment results, reports, records, etc):"
                              fontSize="18px"
                              fontweight={600}
                              className="mt-md mb-md"
                            />
                            <CommentTextbox
                              name="description"
                              className="translate"
                              placeholder={
                                'Enter information used to make this decision here'
                              }
                              rows={5}
                              maxLength={3000}
                              Value={consentDetails.description}
                              handlechange={(value) => {
                                setConsentDetails({
                                  ...consentDetails,
                                  description: value,
                                });
                              }}
                            />
                          </Box>
                          <SingleLine className="width__100 mt-sm mb-sm" />
                        </Box>
                      )}
                    </Box>

                    <Box
                      style={{
                        pointerEvents:
                          hasEditPermission && isAuthorized ? 'auto' : 'none',
                        opacity:
                          hasEditPermission && isAuthorized ? 'unset' : '0.8',
                      }}
                    >
                      {consentForChange && (
                        <Box component="div">
                          <ConsentServiceDeliveryPlan
                            SDPData={consentDetails.serviceDeliveryPlan}
                            contact={consentDetails.contact}
                            disableConsentDueToAssessmentCompletionDate={
                              handleDisableConsentDueToAssessmentCompletionDate
                            }
                            disableConsentDueToReEstablishDate={
                              handleDisableConsentDueToReEstablishDate
                            }
                            onConsentChange={(data) => {
                              setConsentDetails({
                                ...consentDetails,
                                serviceDeliveryPlan: data,
                              });
                            }}
                          />
                        </Box>
                      )}
                    </Box>

                    <Box>
                      {signatureView && (
                        <Box component="div">
                          {consentDetails.type === 'SavingsAcc' &&
                            consentDataJSON?.hsaConsentVersion === 2 && (
                              <MediumTypography
                                fontSize="14px"
                                fontweight={400}
                                textColor={
                                  hasEditPermission && isAuthorized
                                    ? '#2A4241'
                                    : '#97A6A5'
                                }
                                labelid="ConsentForms.certifyText"
                                defaultlabel="I certify that the information provided above is true and accurate to the best of my knowledge."
                                className="pt-md"
                              />
                            )}
                          {noppConsent ? (
                            <Box component="div">
                              <MediumTypography
                                fontSize="18px"
                                fontweight={600}
                                textColor="#2A4241"
                                labelid="ConsentForms.signatureTitleForNoticeofPrivacyPractices"
                                defaultlabel="Acknowledgment of Receipt of Notice of Privacy Practices"
                                className="pt-md pb-md"
                              />
                              <MediumTypography
                                textColor="#2A4241"
                                labelid="ConsentForms.signatureSubTitleForNoticeofPrivacyPractices"
                                defaultlabel="By signing below, I acknowledge that I have been provided with a copy of this Notice of Privacy Practices."
                              />
                            </Box>
                          ) : legalConsent ? (
                            <Box component="div">
                              <MediumTypography
                                textColor="#2A4241"
                                fontSize="16px"
                                fontweight={600}
                                labelid="ConsentForms.signatureSubTitleForLegalReleaseOfRecords"
                                defaultlabel="Who can authorize us to give information to others about your child?"
                                className="pt-md"
                              />
                            </Box>
                          ) : (
                            <MediumTypography
                              fontSize="18px"
                              fontweight={600}
                              textColor="#2A4241"
                              labelid={
                                pwnForm
                                  ? 'ConsentForms.staffSignatureTitle'
                                  : 'ConsentForms.signatureTitle'
                              }
                              defaultlabel={
                                pwnForm ? 'Staff Initials' : 'Signature'
                              }
                              className="pt-md"
                            />
                          )}

                          {!pwnForm ? (
                            <>
                              <DropdownComponent
                                labelid="sspReferral.contact"
                                defaultlabelid="Select Guardian"
                                names={guardianContacts}
                                disabled={
                                  !hasEditPermission ||
                                  !isAuthorized ||
                                  consentDetails.refusal
                                }
                                Required={checkedGuardianRequired()}
                                handleChange={(value) => {
                                  if (value === '') {
                                    setContactSelected(null);
                                    const signatures =
                                      consentDetails.signature.map(
                                        (sign: ConsentClientSignature) => ({
                                          ...sign,
                                          name: '',
                                          email: '',
                                          signature: '',
                                          verbal: false,
                                          partitionKey: '',
                                          rowKey: '',
                                          date: '',
                                          id: '',
                                          isPrimary: false,
                                          relationship: '',
                                          consentSignedDate: '',
                                          isGuardian: false,
                                        }),
                                      );
                                    setConsentDetails({
                                      ...consentDetails,
                                      signedDate: null,
                                      signature: signatures,
                                    });
                                  } else {
                                    const foundContact = guardianContacts.find(
                                      (contact) => contact.id === value,
                                    );
                                    if (foundContact) {
                                      const contact = consentData?.contact.find(
                                        (c) =>
                                          c.id.toString() === foundContact.id,
                                      );
                                      if (contact) {
                                        const signatures =
                                          consentDetails.signature.map(
                                            (sign: ConsentClientSignature) => ({
                                              ...sign,
                                              name: contact.name,
                                              email: contact.email,
                                              signature: '',
                                              verbal: false,
                                              partitionKey: '',
                                              rowKey: '',
                                              isPrimary: contact.isPrimary,
                                              isLegal: contact.isLegalGuardian,
                                              isGuardian: contact.isGuardian,
                                              relationship: contact.type ?? '',
                                              id: contact.id,
                                              date: moment(
                                                sign.date,
                                                'YYYY-MM-DDTHH:mm:ss',
                                              )
                                                .utc(true)
                                                .local()
                                                .format(DATE_FORMAT),
                                            }),
                                          );
                                        setConsentDetails({
                                          ...consentDetails,
                                          signature: signatures,
                                        });
                                      }
                                      setContactSelected(foundContact);
                                    }
                                  }
                                }}
                                value={contactSelected?.id || ''}
                                className="mt-md width400px"
                              />
                              <ConsentSignature
                                signatureData={consentDetails.signature}
                                staffSignature={false}
                                revokeChecked={consentDetails.refusal}
                                onSaveClick={onSaveClick}
                                verbalConsentValue={consentDetails.signature}
                                paperConsentValue={consentDetails.signature}
                                onVerbalConsentClick={onVerbalConsentClick}
                                onPaperConsentClick={onPaperConsentClick}
                                defaultParentGuardianNoId="Guardian Name"
                                parentGuardianNoId="ConsentParentGuardianNoId"
                                relationshipWithChildId="ConsentRelationshipWithChild"
                                defaultRelationshipWithChildId="Guardian Type:"
                                emailId="ConsentEmail"
                                defaultEmailId="Email:"
                                isDateRequired={
                                  consentDetails.signature.length > 0
                                    ? consentDetails.signature[0].name !== ''
                                    : false
                                }
                                isPaperConsentRequired={isPaperConsentView}
                                isVerbalConsentRequired={isVerbalConsentView}
                                viewUpdateId="ConsentViewOrUpdateSignature"
                                defaultViewUpdateId="View/update signature"
                                addSignatureId="ConsentAddSignature"
                                defaultAddSignatureId="Add Signature"
                                verbalConsentId="ConsentVerbalConsent"
                                defaultVerbalConsentId="Verbal Consent"
                                paperConsentId="PaperConsent"
                                defaultPaperConsentId="Paper Consent"
                                parentSignatureId="ConsentParentSignature"
                                defaultParentSignatureId="Guardian Signature"
                                onConsentSignedDateChange={
                                  onConsentSignedDateChange
                                }
                                hasEditPermission={
                                  !hasEditPermission || !isAuthorized
                                }
                              />
                            </>
                          ) : (
                            <ConsentSignature
                              signatureData={consentDetails.signature}
                              onSaveClick={onSaveClick}
                              staffSignature={true}
                              revokeChecked={consentDetails.refusal}
                              nameLabelId="ConsentForms.signatureName"
                              nameDefaultLabelId="Name:"
                              licenseLabelId="ConsentForms.signatureLicense"
                              licenseDefaultLabelId="License:"
                              viewUpdateId="ConsentViewOrUpdateSignature"
                              defaultViewUpdateId="View/update signature"
                              addSignatureId="ConsentAddSignature"
                              defaultAddSignatureId="Add Signature"
                              parentSignatureId={
                                pwnForm
                                  ? 'ConsentStaffSignature'
                                  : 'ConsentParentSignature'
                              }
                              defaultParentSignatureId={
                                pwnForm
                                  ? 'Staff Signature'
                                  : 'Guardian Signature'
                              }
                            />
                          )}
                          <SingleLine className="width__100 mt-sm mb-sm" />

                          {uorView && (
                            <Box component="div">
                              <Box
                                style={{
                                  pointerEvents:
                                    consentData?.status === 'Revoked' ||
                                    isConsentSigned()
                                      ? 'none'
                                      : 'auto',
                                  opacity:
                                    consentData?.status === 'Revoked' ||
                                    isConsentSigned()
                                      ? '0.8'
                                      : 'unset',
                                }}
                              >
                                <MediumTypography
                                  className="mainText-lg pt-md"
                                  labelid="ConsentForms.refusalTitle"
                                  defaultlabel="Understanding of Refusal"
                                />
                                <Grid
                                  container
                                  rowSpacing={'24px'}
                                  columnSpacing={'20px'}
                                >
                                  <Grid item>
                                    <CheckBoxComponent
                                      labelid="Consentrefusal.labelText"
                                      defaultlabelid="I do not wish to give my permission"
                                      ischecked={checked}
                                      disabled={
                                        isConsentSigned() || !isAuthorized
                                      }
                                      CheckHandleChange={(
                                        value: React.ChangeEvent<HTMLInputElement>,
                                      ) => onChecked(value.target.checked)}
                                    />
                                  </Grid>
                                </Grid>
                              </Box>

                              {consentDetails.refusal && (
                                <Box>
                                  <DropdownComponent
                                    labelid="sspReferral.contact"
                                    defaultlabelid="Select Guardian"
                                    names={guardianContacts}
                                    disabled={
                                      consentData?.status === 'Revoked' ||
                                      !isAuthorized
                                    }
                                    Required={checkedGuardianRequired()}
                                    handleChange={(value) => {
                                      if (value === '') {
                                        setRevokeGuardian(null);
                                        setConsentDetails({
                                          ...consentDetails,
                                          revokeSignature: null,
                                        });
                                      } else {
                                        const foundContact =
                                          guardianContacts.find(
                                            (contact) => contact.id === value,
                                          );
                                        if (foundContact) {
                                          const contact =
                                            consentData?.contact.find(
                                              (c) =>
                                                c.id.toString() ===
                                                foundContact.id,
                                            );
                                          if (contact) {
                                            setConsentDetails({
                                              ...consentDetails,
                                              revokeSignature: {
                                                name: contact.name,
                                                email: contact.email,
                                                signature: '',
                                                verbal: false,
                                                paperConsent: false,
                                                partitionKey: '',
                                                rowKey: '',
                                                isPrimary: contact.isPrimary,
                                                isLegal:
                                                  contact.isLegalGuardian,
                                                relationship:
                                                  contact.type ?? '',
                                                id: contact.id,
                                                isGuardian: contact.isGuardian,
                                              },
                                            });
                                          }
                                          setRevokeGuardian(foundContact);
                                        }
                                      }
                                    }}
                                    value={revokeGuardian?.id || ''}
                                    className="mt-md width400px"
                                  />

                                  <ConsentSignature
                                    signatureData={
                                      consentDetails.revokeSignature
                                        ? [
                                            {
                                              ...consentDetails.revokeSignature,
                                            },
                                          ]
                                        : []
                                    }
                                    minDate={getConsentMinimumDate()}
                                    staffSignature={false}
                                    revokeChecked={consentDetails.refusal}
                                    onSaveClick={onRevokeSignatureSaveClick}
                                    verbalConsentValue={[
                                      {
                                        verbal:
                                          consentDetails.revokeSignature
                                            ?.verbal || false,
                                      },
                                    ]}
                                    paperConsentValue={[
                                      {
                                        paperConsent:
                                          consentDetails.revokeSignature
                                            ?.paperConsent || false,
                                      },
                                    ]}
                                    onVerbalConsentClick={
                                      onRevokeSignatureVerbalConsentClick
                                    }
                                    onPaperConsentClick={
                                      onRevokeSignaturePaperConsentClick
                                    }
                                    isPaperConsentRequired={isPaperConsentView}
                                    isVerbalConsentRequired={
                                      isVerbalConsentView
                                    }
                                    defaultParentGuardianNoId="Guardian Name"
                                    parentGuardianNoId="ConsentParentGuardianNoId"
                                    relationshipWithChildId="ConsentRelationshipWithChild"
                                    defaultRelationshipWithChildId="Guardian Type:"
                                    emailId="ConsentEmail"
                                    defaultEmailId="Email:"
                                    isDateRequired={consentDetails.refusal}
                                    viewUpdateId="ConsentViewOrUpdateSignature"
                                    defaultViewUpdateId="View/update signature"
                                    addSignatureId="ConsentAddSignature"
                                    defaultAddSignatureId="Add Signature"
                                    verbalConsentId="ConsentVerbalConsent"
                                    defaultVerbalConsentId="Verbal Consent"
                                    paperConsentId="PaperConsent"
                                    defaultPaperConsentId="Paper Consent"
                                    parentSignatureId="ConsentParentSignature"
                                    defaultParentSignatureId="Guardian Signature"
                                    onConsentSignedDateChange={
                                      onRevokeConsentSignDateChange
                                    }
                                    hasEditPermission={
                                      consentData?.status === 'Revoked' ||
                                      !isAuthorized
                                    }
                                  />
                                </Box>
                              )}
                            </Box>
                          )}
                        </Box>
                      )}
                    </Box>

                    <Box
                      style={{
                        pointerEvents:
                          hasEditPermission && isAuthorized ? 'auto' : 'none',
                        opacity:
                          hasEditPermission && isAuthorized ? 'unset' : '0.8',
                      }}
                    >
                      {pwnForm && staffInitialsView && (
                        <Box component="div">
                          <MediumTypography
                            fontSize="18px"
                            fontweight={600}
                            textColor="#2A4241"
                            labelid={'ConsentForms.staffSignatureTitle'}
                            defaultlabel={'Staff Initials'}
                            className="pt-md"
                          />
                          <Grid container columnGap={2}>
                            <Grid item xs={4}>
                              <Textinput
                                className="mt-sm"
                                labelid={'ConsentForms.staffSignatureTitle'}
                                defaultlabelid={'Staff Initials'}
                                inputProps={{ maxLength: 10 }}
                                handlechange={(value) => {
                                  setConsentDetails({
                                    ...consentDetails,
                                    initials: value,
                                  });
                                }}
                                disabled={!hasEditPermission || !isAuthorized}
                                Value={consentDetails.initials}
                              />
                            </Grid>
                            <Grid item xs={4}>
                              <DatePickerComponent
                                className="width400px mt-sm"
                                labelid={'ConsentForms.DateMailed/Delivered'}
                                defaultlabelid={'Date Mailed/Delivered'}
                                value={
                                  consentDetails.dateMailed
                                    ? dayjs(
                                        consentDetails.dateMailed,
                                        DATE_FORMAT,
                                      )
                                    : null
                                }
                                handlechange={(date) => {
                                  if (date) {
                                    const formatedDate =
                                      dayjs(date).format(DATE_FORMAT);
                                    if (formatedDate) {
                                      setConsentDetails({
                                        ...consentDetails,
                                        dateMailed: formatedDate,
                                      });
                                    }
                                  } else {
                                    setConsentDetails({
                                      ...consentDetails,
                                      dateMailed: '',
                                    });
                                  }
                                }}
                              />
                              {datePickerMinDateMaxDateValidate(
                                consentDetails.dateMailed,
                              ) && (
                                <Box className="loginError">
                                  <MediumTypography
                                    labelid="datePickerMinDateMaxDateValidate"
                                    defaultlabel="Enter a date between 01/01/1900 and 01/01/2100"
                                    className="errorText-md"
                                  />
                                </Box>
                              )}
                            </Grid>
                          </Grid>
                          <SingleLine className="width__100 mt-sm mb-sm" />
                        </Box>
                      )}

                      {disclaimerView && (
                        <Box component="div">
                          {disclaimerTitleView && (
                            <MediumTypography
                              fontSize="18px"
                              fontweight={600}
                              textColor="#2A4241"
                              labelid="ConsentForms.disclaimerTitle"
                              defaultlabel="Disclaimer"
                              className="pb-sm pt-md"
                            />
                          )}
                          <Typography
                            dangerouslySetInnerHTML={{ __html: disclaimer }}
                            sx={{
                              fontFamily: 'Lato-Regular',
                              fontSize: '14px',
                              fontWeight: 400,
                            }}
                          />
                        </Box>
                      )}
                    </Box>
                  </Card>
                  {isAuthorized && (
                    <Box className="p-lg pr-none justifyContent-FlexEnd flex__ mb-md">
                      <ButtonComponent
                        className="btn-primary btn-cancel mr-md"
                        labelId={btnName ? 'ConsentBack' : 'ConsentCancel'}
                        defaultLabelId="Cancel"
                        variantType="outlined"
                        sxProps={{
                          display:
                            hasEditPermission ||
                            (consentData?.status !== 'Revoked' &&
                              consentDetails.refusal)
                              ? 'auto'
                              : 'none',
                        }}
                        onClick={() => {
                          const extractedId = selectedContact.map(
                            (data) => data.id,
                          );
                          if (
                            _.isEqual(consentBackupDetails, consentDetails) &&
                            _.isEqual(
                              otherInitialContactName,
                              otherContactName,
                            ) &&
                            _.isEqual(initialSelectedContactId, extractedId)
                          ) {
                            setOpenModal(false);
                            localStorage.removeItem('consentDataJSON');
                            localStorage.removeItem('selectedVersionNo');
                            navigate(CONSENT_DASHBOARD);
                          } else {
                            setOpenModal(true);
                          }
                        }}
                      />
                      <ButtonComponent
                        className="btn-primary btn-submit"
                        labelId="clientpage.Update"
                        defaultLabelId=""
                        variantType="contained"
                        disabled={
                          disableConsentDueToReEstablishDate ||
                          disableConsentDueToAssessmentCompletionDate
                        }
                        sxProps={{
                          display:
                            hasEditPermission ||
                            (consentData?.status !== 'Revoked' &&
                              consentDetails.refusal)
                              ? 'auto'
                              : 'none',
                        }}
                        onClick={handleSave}
                      />
                    </Box>
                  )}
                </Box>
              </Box>
            </Box>
          </Box>
        )}
      </TranslateWidget>
    </Box>
  );
};

export default ConsentReleaseInfo;
